/**
 * Bosh sahifadagi «Yangiliklar va ekotadbirlar» bloki: so'nggi 4 ta xabar,
 * «Barcha yangiliklar» — to'liq ro'yxat, kartochka — maqola sahifasi.
 * Blokning `id`si (`yangiliklar`) menyudagi «Yangiliklar» bandi tushadigan joy.
 *
 * «gov.uz/urmon dan avtomatik yangilanadi» yozuvi faqat integratsiya haqiqatan
 * ishlaganda chiqadi (`news_feed.live`); namunaviy xabarlar «Namuna» bilan belgilanadi.
 */
import { Link } from "react-router-dom";

import { useI18n } from "@/shared/i18n";
import { useReveal } from "@/shared/lib/motion";
import { NEWS_ANCHOR, SECTION_PATHS } from "@/shared/lib/sectionRoutes";
import { Icon } from "@/shared/ui/Icon";

import { NewsCard, NewsSkeleton, useHomeNews } from "./news";

const HOME_COUNT = 4;

export function NewsSection() {
  const { t } = useI18n();
  const { items, loading, sample, live } = useHomeNews(HOME_COUNT);

  /* CMS yangiliklari kelganda ko'rinish animatsiyasi yangi kartochkalarni ham qamrab oladi. */
  useReveal([items.map((item) => item.id).join(",")]);

  return (
    <section className="section home-news" id={NEWS_ANCHOR} aria-labelledby="news-title">
      <div className="container">
        <div className="home-head" data-reveal>
          <div>
            <span className="eyebrow">{t("nav.news")}</span>
            <h2 id="news-title">{t("news.title")}</h2>
            <p className="section-lead">
              {live ? (
                <span className="news-auto">
                  <Icon name="refresh" size={14} /> {t("news.auto")}
                </span>
              ) : (
                t("news.lead")
              )}
            </p>
          </div>
          <Link className="btn btn-outline" to={SECTION_PATHS.news}>
            {t("news.all")}
            <Icon name="arrowRight" size={16} />
          </Link>
        </div>

        {sample ? (
          <p className="news-sample-note" role="note">
            <Icon name="info" size={16} />
            {t("news.sampleNote")}
          </p>
        ) : null}

        <div className="news-grid is-four" aria-busy={loading}>
          {loading ? (
            <NewsSkeleton count={HOME_COUNT} />
          ) : (
            items.map((item, index) => <NewsCard key={item.id} item={item} index={index} />)
          )}
        </div>
      </div>
    </section>
  );
}
